import styled from '@emotion/styled';

export const DescriptionContainer = styled('div')`
  margin-bottom: 24px;
  font-size: 14px;
  color: var(--000000A6-antd);
  font-weight: 400;
`;
